"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconLightweight = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.99 3.57a.505.505 0 00-.42-.57.493.493 0 00-.57.42c-.19 1.22-.48 2.32-.87 3.33-.35.94-1.36 1.42-2.33 1.15-1.28-.37-2.51-.58-3.7-.66-.81-.04-1.49 0-2.12.13-.08.01-.15.04-.23.06l-1.09.3s-2.74 1-4.35 3.05c-.03.05-1.76 1.95-1.76 1.95-.27.31-.53.58-.8.85-.77.72-1.53 1.34-2.3 1.87-.52.35-1.1.64-1.68.93l-.15.07c-.11.06-.29.08-.46.12l-.2.04c-.5.1-.85.43-.91.88H.01c-.08.49.16.91.63 1.13 1.9.9 4.01 1.36 6.28 1.37 2.43.01 4.88-.49 7.27-1.51 1.22-.51 2.5-1.08 3.68-1.89.71-.49 1.32-.99 1.87-1.53 1.05-1.04 1.8-2.18 2.28-3.47.07-.19.12-.38.18-.57.04-.14.07-.28.12-.41.02-.07.05-.15.15-1.53a.475.475 0 00-.12-.34c.77-1.47 1.35-3.19 1.65-5.18l-.01.01zM12.45 8.91s.92-.4 1.81-.57c.5-.1 1.09-.13 1.79-.09.64.03 1.28.12 1.95.24 3.44.37 2.87 1.39.97 3.15l-.02.02s-.07.06-.1.09l-8.21-1.82c.18-.15 1.34-.86 1.8-1.01l.01-.01zm3.65 6.73c-.11.61-.51 1.13-1.07 1.39-.4.19-.8.36-1.2.53-2.3.97-4.55 1.44-6.88 1.43-2.11-.03-4.08-.45-5.85-1.29-.06-.08-.02-.1.06-.12l.18-.03c.24-.04.49-.09.74-.21l.15-.07c.6-.3 1.23-.61 1.8-1 .94-.64 1.85-1.4 2.79-2.31.17-.18.34-.35.51-.55L9 11.61l.12-.12s.54-.63.78-.87l8.19 1.82c-1.09.9-2.28 1.62-3.47 2.18-.38.18-.82.21-1.24.12l-4.05-.96-.59-.14c-.19-.05-.41.07-.48.28-.06.19.03.38.21.44 0 0 2.56.64 4.33 1.05-1.84.61-5.08 1.59-6.88 1.56-.26 0-.45.19-.45.43s.19.44.44.45h.08c2.69 0 7.93-1.88 8.47-2.07.02 0 .03 0 .04-.01.02 0 .04-.02.06-.03.56-.24 1.12-.5 1.68-.81l-.12.73-.02-.02zm5.14-4.86c-.04.16-.08.33-.14.48-.65 1.74-1.88 3.22-3.77 4.51-.07.06-.16.1-.25.15l.16-.95c.08-.47.35-.88.75-1.16.12-.1.25-.21.38-.31-.07.05-.13.1-.19.14.06-.05.12-.1.19-.15.11-.08.22-.16.33-.25.36-.3.71-.6 1.05-.94.57-.57 1.11-1.21 1.6-1.91-.04.1-.07.23-.11.37v.02z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconLightweight, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;